import { withFilters } from 'coreOld/components';
import { SortDirection } from 'coreOld/enums';
import { IFiltersProps } from 'coreOld/types';
import { getListPayload } from 'coreOld/utils';
import { useGetInventoryList } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';

import { columns } from './columns';
import InventoryListView from './InventoryListView';

interface IProps extends IFiltersProps {
  part?: Partial<ICompanyPart>;
}

const getPayload = (part: Partial<ICompanyPart>) => {
  return getListPayload(
    { part: [part?.part], manufacturerId: part?.manufacturerId },
    {
      sortField: ['location_name'],
      sortDir: [SortDirection.ASC],
    }
  );
};

const InventoryList = ({ part, filters }: IProps) => {
  const requestPayload = getPayload(part);

  const { records, totals, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } =
    useGetInventoryList({
      ...requestPayload,
      filters: { ...requestPayload.filters, ...filters },
    });

  return (
    <InventoryListView
      tableColumns={columns(totals)}
      inventoryList={records}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default withFilters(InventoryList);
